import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from '../../services/general/general.service';
import { BehaviorSubject, forkJoin as join, Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.scss'],
})
export class PremiumComponent implements OnInit {
  public loading = false;
  // we create form variable
  public form: FormGroup;

  public user: any;
  public userInfo: any;

  response_cupon :any;
  public price_suscription:any = 9.99;

  constructor(
    public general: GeneralService,
    private formBuilder: FormBuilder
  ) {

    this.form = this.formBuilder.group({
      hours: [1, [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      couponText: [''],
      conditions: ['', [Validators.required]],
    });
  }

  async ngOnInit() {
    await this.getUserInfo();
  }

  ngAfterViewInit() {
    //control aceptar términos
    this.form.controls['conditions'].valueChanges.subscribe(change => {
      if(this.form.controls['conditions'].value == false) {
        this.form.controls['conditions'].setErrors({'incorrect': true});
      }
    });
  }
  
  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  //We call service for payment
  async buyPremium() {
    try {
      // if (this.form.value.paymentMethod === 'paypal') {
      //   await this.general.showDanger('paypal-failed');
      //   return;
      // }

      this.loading = true;
      
      const response = await this.general.httpPost('premium-buy', {
        premium_months: 1,
        payment_method: this.form.value.paymentMethod,
        coupon_text: this.form.value.couponText
      });
      const path = await response.data.data;
      await console.log('response', response);
      await console.log('path', path);
      await this.goToExternalUrl(path);
      // await this.general.showSuccess('email-sent-successfully');
    } catch (error: any) {
      await this.general.showErrorForm(error);
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  goToDasboard() {
    // TODO modificar redirección de usuario para activar la suscripción premium por cupon, actualmente se debe cerrar la sesión y volver a abrir
    try {
      localStorage.clear();
      this.general.navigate('/auth/login');
    } catch (error: any) {
      this.general.showDanger(error.message);
    }
  }

  // todo Consumir cupón
  async checkCoupon() {    
    this.general.setLoading(true);  


        try {

            const response = await this.general.httpPost(
              'coupon-check',
              {
                coupon_text: this.form.value.couponText,
                user_id: this.user.id,
              }
            ); 

            if (response.success==true) {
              this.response_cupon = response.data;      
            } 
            
           

            if (response.data.coupon.discount_type==0) {
              this.price_suscription = response.data.coupon_data.price_premium;
            }

            if (response.data.coupon.discount_type==1) {
              this.price_suscription = response.data.coupon_data.price_premium;;
            }

            if (response.data.coupon.discount_type==3) {
              //actualizamos info de usuario
              await this.getUserInfo();
            }

        } catch(error) {
          //  console.log(error);
            await this.general.showDanger('El cupón introducido no es válido.');
            //this.form.controls['coupon_text'].patchValue('');
            this.form.controls.couponText.patchValue('');
           
            //console.log("coupon_text", this.form.controls['coupon_text']);
            
            
            
            
          }
   
    
}

  goToExternalUrl(path: string) {
    window.location.href = path;
  }
}
